import type { Candidate } from '../repository'

import heroMinimalMeta from '@cogo/schema/blocks-v2/hero/hero-minimal/block.cogo.json'
import heroMinimalUi from '@cogo/schema/blocks-v2/hero/hero-minimal/ui.cogo.json'
import heroMinimalEvents from '@cogo/schema/blocks-v2/hero/hero-minimal/events.cogo.json'
import heroMinimalFlow from '@cogo/schema/blocks-v2/hero/hero-minimal/flow.cogo.json'
import heroMinimalVariables from '@cogo/schema/blocks-v2/hero/hero-minimal/variables.cogo.json'
import heroMinimalDatasource from '@cogo/schema/blocks-v2/hero/hero-minimal/datasource.cogo.json'
import { cloneBlockDef, appendRootClassName } from './util'

function buildHeroVariant(variant: 'default' | 'dark' | 'splitLayout') {
  const base = cloneBlockDef({
    meta: heroMinimalMeta,
    ui: heroMinimalUi,
    events: heroMinimalEvents,
    flow: heroMinimalFlow,
    state: heroMinimalVariables,
    data: heroMinimalDatasource,
  })
  if (variant === 'dark') appendRootClassName(base, 'bg-gray-950 text-white')
  if (variant === 'splitLayout') appendRootClassName(base, 'grid grid-cols-2')
  return base
}

export const wizardCandidates: Candidate[] = [
  {
    id: 'wizard-a',
    exampleId: 'cexample:hero-minimal-default',
    patternId: 'cpat:hero-banner',
    dsId: 'ds:shadcn',
    cogoJson: buildHeroVariant('default'),
    narrativeHeadline: 'Minimal hero · clean above-the-fold',
    dsCompatibility: 'exact',
    score: 90,
  },
  {
    id: 'wizard-b',
    exampleId: 'cexample:hero-minimal-dark',
    patternId: 'cpat:hero-banner',
    dsId: 'ds:shadcn',
    cogoJson: buildHeroVariant('dark'),
    narrativeHeadline: 'Dark-mode hero · high-contrast landing',
    dsCompatibility: 'exact',
    score: 85,
  },
  {
    id: 'wizard-c',
    exampleId: 'cexample:hero-minimal-split-layout',
    patternId: 'cpat:hero-banner',
    dsId: 'ds:shadcn',
    cogoJson: buildHeroVariant('splitLayout'),
    narrativeHeadline: 'Split-layout hero · text + visual columns',
    dsCompatibility: 'adjacent',
    score: 78,
  },
]
